import { useQuery } from "@tanstack/react-query";
import { DEPLOYMENT_TEMPLATES_PAGE_SIZE } from "../../constants/pdm";
import { getDeploymentTemplates } from "../../services/pdmApi.service";

export function useDeploymentTemplatesList(page: number) {
  const pageSize = DEPLOYMENT_TEMPLATES_PAGE_SIZE;

  return useQuery({
    queryKey: ["deploymentTemplates", page, pageSize],
    queryFn: () =>
      getDeploymentTemplates({
        offset: page * pageSize,
        limit: pageSize,
      }),
  });
}
